import { Reducer, ReducersMapObject } from "redux";

type Listener = (reducers: ReducersMapObject) => void;

class ReducerRegistry {
  private listeners: Array<Listener> = [];

  private reducers: Map<string, Reducer> = new Map();

  public subscribe(listener: Listener) {
    this.listeners.push(listener);
  }

  public unsubscribe(listener: Listener) {
    this.listeners.splice(this.listeners.indexOf(listener), 1);
  }

  public register(name: string, reducer: Reducer) {
    if (!this.reducers.has(name)) {
      this.reducers.set(name, reducer);
      this.emit(this.getReducers());
    } else if (this.reducers.get(name) !== reducer) {
      console.warn("Warning: trying replace registered reducer. Change reducer name.");
    }
  }

  public getReducers(): ReducersMapObject {
    const reducersMap: ReducersMapObject = {};

    for (const [key, value] of this.reducers) {
      reducersMap[key] = value;
    }

    return reducersMap;
  }

  private emit(reducers: ReducersMapObject) {
    this.listeners.forEach(listener => {
      listener(reducers);
    });
  }
}

export const reducerRegistry = new ReducerRegistry();
